var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vip',{attrs:{"type_client":'communication',"itemFilter":_vm.ruleForUser}})
}
var staticRenderFns = []

export { render, staticRenderFns }